import React, { FunctionComponent, useEffect } from 'react';

import { UiButton } from '@shared/ui';

import { ModalBody } from '../../../../../TemporaryConmonents/Gant/components/UI/Modal/ModalBody/ModalBody';
import { ModalFooter } from '../../../../../TemporaryConmonents/Gant/components/UI/Modal/ModalFooter/ModalFooter';
import cls from '../../PrevMedia.module.css';

interface DeleteImageProps {
    onHideModal: () => void;
    isShow: boolean;
    deleteImage?: () => void;
}

export const DeleteImage: FunctionComponent<DeleteImageProps> = ({
    onHideModal,
    isShow,
    deleteImage,
}) => {
    const handleEscapeDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            onHideModal();
            event.stopPropagation();
        }
        if (event.key === 'Enter') {
            deleteImage();
            event.stopPropagation();
        }
        event.stopPropagation();
    };

    useEffect(() => {
        if (isShow) {
            const deleteButton = document.querySelector('.deleteButton');
            if (deleteButton) {
                deleteButton.focus();
            }
            document.addEventListener('keydown', handleEscapeDown);
        }
        return () => {
            document.removeEventListener('keydown', handleEscapeDown);
        };
    }, [isShow, onHideModal]);
    return (
        <>
            <ModalBody width="476px" classes={cls.textAlignCenter}>
                Вы уверены, что хотите удалить файл?
            </ModalBody>
            <ModalFooter classes={cls.textAlignCenter}>
                <UiButton onClick={deleteImage} btnText="Удалить" btnColor="danger" />
                <UiButton onClick={onHideModal} btnText="Отменить" btnColor="secondary" />
            </ModalFooter>
        </>
    );
};
